import { Component, ChangeDetectionStrategy, viewChild, inject, input, computed, signal, DestroyRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { filter, first, map, switchMap } from 'rxjs/operators';
import { MenuComponent } from '../menu/menu.component';
import { DateTime } from 'luxon';
import { LocationService } from '../../../location.service';
import { Store } from '../../../types';
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop';
import { ToastrService } from 'ngx-toastr';
import { HttpClient } from '@angular/common/http';
import { backend } from '../../../../environments/environment';
import { Platform } from '@angular/cdk/platform';

@Component({
  selector: 'menu-outlet',
  templateUrl: './menu-outlet.component.html',
  styleUrls: ['./menu-outlet.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MenuComponent]
})
export default class MenuOutletComponent {
  router = inject(LocationService);
  activated = inject(ActivatedRoute);
  toast = inject(ToastrService);
  http = inject(HttpClient);
  platform = inject(Platform);
  destroy = inject(DestroyRef);

  menu = viewChild<MenuComponent>(MenuComponent);

  brand = input<string>();
  store = input<string>();

  menu_stores = signal<Store[]>([]);

  type = computed(() => {
    if(this.brand()){
      return 'brand';
    }

    if(this.store()){
      return 'store';
    }

    return 'none';
  });

  identifier = computed(() => {
    return this.brand() || this.store() || null;
  });

  constructor() {
    toObservable(this.identifier).pipe(
      filter(identifier => typeof identifier == 'string' && this.type() != 'none'),
      map((identifier) => {
        let shouldSkip = false;
        if(this.type() == 'store' && this.platform.isBrowser){
          try {
            const lastRequest = localStorage?.getItem(`m-${this.identifier()!}`);
            if(!lastRequest){
              localStorage?.setItem(`m-${this.identifier()!}`, String(Date.now()));
            } else {
              const lastDate = DateTime.fromMillis(Number(lastRequest));
              if(lastDate && lastDate.isValid && DateTime.now().diff(lastDate, 'hour').as('hour') < 4){
                shouldSkip = true;
              }
            }
          } catch (e){}
        }
        return { identifier: identifier!, skip: shouldSkip?'1':'0' }
      }),
      switchMap(({identifier, skip }) => this.http.get<Store[]>(backend + 'store/menus', { params: { type: this.type()!, identifier, skip } })), 
      takeUntilDestroyed(this.destroy)
    ).subscribe({
      next: data => {
        this.menu_stores.set(data);
      },
      error: error => {
        this.toast.error(`Could not get menu data. ${error.message}`);
        this.router.navigate(['/menus']);
      }
    });
  }
 

}
